<router-outlet></router-outlet>

<uni-loader *ngIf="isLoaderActive"></uni-loader>
